import PropTypes from 'prop-types';

import {
  ClassNameDefaultProps,
  ClassNamePropTypes,
} from '@/common/proptypes/Base/ClassName.protypes';

export const ClassDefaultProps = {
  ...ClassNameDefaultProps,
  code: null,
  content: null,
  id: null,
  image: null,
  label: null,
  loyalty_points_amount: null,
  loyalty_points_ratio: null,
  period: null,
  steps: [],
  url: null,
};

export const ClassPropTypes = {
  ...ClassNamePropTypes,
  code: PropTypes.string,
  content: PropTypes.string,
  id: PropTypes.number,
  image: PropTypes.object,
  label: PropTypes.string,
  loyalty_points_amount: PropTypes.number,
  loyalty_points_ratio: PropTypes.number,
  period: PropTypes.string,
  steps: PropTypes.arrayOf(PropTypes.shape({})),
  url: PropTypes.string,
};
